import { action, observable } from 'mobx';
import client from 'src/services/client';
import { extractHtmlContent, getRestaurantName, logError, setMetaTags } from 'src/utils/helpers';
import 'moment/locale/ar';
import { localeStore } from '../localesStore';

export class InfoStore {
  @observable loading: boolean = false;
  @observable template: string = '';

  private setMetaTags = (section: string) => {
    let sectionName = '';

    switch (section) {
      case 'franchise':
        sectionName = 'consumer_franchise_section_hdr';
        break;
      case 'about':
        sectionName = 'txt_about';
        break;
      case 'privacy':
        sectionName = 'title_privacy';
        break;
      case 'terms':
        sectionName = 'txt_terms';
        break;
      default:
        sectionName = '';
        break;
    }

    setMetaTags({
      title: `${getRestaurantName()} - ${localeStore.t(sectionName)}`,
      keywords: `${getRestaurantName()}, ${localeStore.t(sectionName)}`,
      'og:title': `${getRestaurantName()} - ${localeStore.t(sectionName)}`,
      description: `${extractHtmlContent(this.template)}`,
      'og:description': `${extractHtmlContent(this.template)}`,
    });
  };

  @action public getInfo = async (section: string) => {
    try {
      this.loading = true;
      const { template } = await client.get(`/v3/info/${section}`);
      this.template = template;
    } catch (error) {
      logError(error);
    } finally {
      this.loading = false;
      this.setMetaTags(section);
    }
  };

  @action public resetStore = () => {
    this.loading = false;
    this.template = '';
  };
}

const infoStore = new InfoStore();

export { infoStore };
